/**
 * Academic years named by their start year, the way schools write them:
 * 2027 → "2027–28". Mirrors yearLabel in backend enquiryService.
 */

export const yearLabel = (y: number) => `${y}–${String((y + 1) % 100).padStart(2, '0')}`;

/** This year and the next few — what a family can ask admission for. */
export const upcomingYears = (count = 6): number[] => {
  const now = new Date().getFullYear();
  return Array.from({ length: count }, (_, i) => now + i);
};
